<template>
  <div>
    <label v-if="typeof date == 'object' && date !== null">{{date.toShortDateString()}}</label>
    <label v-if="typeof date == 'string'">{{new Date(date).toShortDateString()}}</label>
  </div>
</template>

<script>
export default {
  props: ["date"]
};
</script>

<style lang="scss">
</style>
